import React from "react";
import { Modal, Form, Input, Select } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import { addFirmwareModel } from "@/fetch/fetchApi";

class AddModal extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  // 设置Form的ref
  formRef = React.createRef();

  handleSubmit = () => {
    const { validateFields } = this.formRef.current;

    validateFields()
      .then((values) => {
        fetchHandler(addFirmwareModel, values).then((res) => {
          if (res && res.code === "success") {
            this.props.refresh();
            this.props.onCancel();
          }
        });
      })
      .catch(() => {
      });
  };

  render() {
    return (
      <Modal title="添加固件型号" visible onCancel={this.props.onCancel} onOk={this.handleSubmit}>
        <Form labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} ref={this.formRef}>
          <Form.Item
            label="固件型号"
            initialValue={this.props.record.frameType}
            name="frameType"
            rules={[{ required: true, message: "请输入固件型号" }]}>
            <Input placeholder="" maxLength={20}></Input>
          </Form.Item>
          <Form.Item
            label="设备型号"
            initialValue={this.props.record.acDc}
            name="acDc"
            rules={[{ required: true, message: "请选择" }]}>
            <Select placeholder="请选择">
              <Select.Option value="DC">直流</Select.Option>
              <Select.Option value="AC">交流</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="CMOS类型"
            initialValue={this.props.record.cmosType}
            name="cmosType"
            rules={[{ required: true, message: "请输入CMOS类型" }]}>
            <Input placeholder="" maxLength={20}></Input>
          </Form.Item>
          <Form.Item
            label="备注"
            initialValue={this.props.record.info}
            name="info"
            rules={[{ required: true, message: "请输入备注" }]}>
            <Input.TextArea maxLength={100} />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default AddModal;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/firmwareVersionManage/addModal.js